'use strict';

var REQUIRED_FIELDS = ['#address1', '#externalNumber', '#neighborhood', '#city', '#state', '#zipCode', '#phone', '#firstName', '#lastName'];

var FIELD_REGEXES = {
    address1: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s\(\)\.,\-]+$/,
    city: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s]+$/,
    neighborhood: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s\(\)\.,\-]+$/,
    firstName: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s]+$/,
    lastName: /^[A-Za-zÁÉÍÓÚáéíóúÜüÑñ\s]+$/,
    postalCode: /^\d{5}$/,
    phone: /^\+52 \d{2}(-\d{4}){2}|\d{10}$/,
    interiorNumber: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s]*$/,
    externalNumber: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ0-9\s.\-\/\\#]*$/,
    addressId: /^[A-Za-z0-9ÁÉÍÓÚáéíóúÜüÑñ\s]+$/
};

var ADDRESS_FIELD_RULES = {
    firstName: { required: true, regex: FIELD_REGEXES.firstName },
    lastName: { required: true, regex: FIELD_REGEXES.lastName },
    address1: { required: true, regex: FIELD_REGEXES.address1 },
    city: { required: true, regex: FIELD_REGEXES.city },
    postalCode: { required: true, regex: FIELD_REGEXES.postalCode },
    stateCode: { required: true },
    neighborhood: { required: true, regex: FIELD_REGEXES.neighborhood },
    phone: { required: true, regex: FIELD_REGEXES.phone },
    externalNumber: { required: true, regex: FIELD_REGEXES.externalNumber },
    interiorNumber: { regex: FIELD_REGEXES.interiorNumber }
};

var ACCOUNT_FIELD_SELECTORS = {
    address1: '#address1',
    city: '#city',
    neighborhood: '#neighborhood',
    firstName: '#firstName',
    lastName: '#lastName',
    postalCode: '#zipCode',
    phone: '#phone',
    externalNumber: '#externalNumber',
    interiorNumber: '#interiorNumber',
    addressId: '#addressId'
};

var CHECKOUT_FIELD_SELECTORS = {
    address1: '[name$=_address1]',
    externalNumber: '[name$=_externalNumber]',
    neighborhood: '[name$=_neighborhood]',
    city: '[name$=_city]',
    stateCode: '[name$=_stateCode]',
    postalCode: '[name$=_postalCode]',
    phone: '[name$=_phoneDisplay]',
    firstName: '[name$=_firstName]',
    lastName: '[name$=_lastName]',
    interiorNumber: '[name$=_interiorNumber]',
    addressId: '[name$=_addressId]'
};

module.exports = {
    CHECKOUT_STEPS: {
        CUSTOMER: 1,
        SHIPPING: 2,
        PAYMENT: 3,
        SUMMARY: 4,
        PLACE_ORDER: 5
    },
    GOOGLE_PLACES_AUTOCOMPLETE: {
        MIN_CHARS: 3,
        DEBOUNCE_MS: 150
    },
    GOOGLE_ADDRESS: {
        REQUIRED_COMPONENTS: ['streetName', 'streetNumber', 'neighborhood', 'postalCode']
    },
    LOCKER_SHIPPING_METHOD_ID: 'pickup-locker',
    REQUIRED_FIELDS: REQUIRED_FIELDS,
    FIELD_REGEXES: FIELD_REGEXES,
    ADDRESS_FIELD_RULES: ADDRESS_FIELD_RULES,
    ACCOUNT_FIELD_SELECTORS: ACCOUNT_FIELD_SELECTORS,
    CHECKOUT_FIELD_SELECTORS: CHECKOUT_FIELD_SELECTORS
}
